import { createListApiSchema } from '../General/schemas';
import z from 'zod';

export const blocklistSourceSchema = z.enum(['manual', 'screening']);

// What a match does: block the person, or flag them for manual review.
export const blocklistActionSchema = z.enum(['block', 'review']);

export const blocklistSchema = z
	.object({
		id: z.string(),
		firstName: z.string().optional(),
		lastName: z.string().optional(),
		phone: z.string().optional(),
		email: z.string().optional(),
		idNumber: z.string().optional(),
		userId: z.string().optional(),
		dateOfBirth: z.coerce.date().optional(),
		imported: z.boolean().optional(),
		expiresAt: z.coerce.date().optional(),
		keywords: z.string().optional(),
		source: blocklistSourceSchema.default('manual'),
		action: blocklistActionSchema.default('block'),
		screeningData: z.any().optional(),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
	})
	.describe('Blocklist');

export const blocklistApiResponseSchema = createListApiSchema(blocklistSchema).describe('BlocklistList');
